import React, { useContext, useState, useEffect, FC } from 'react';

import AddCircleRounded from '@material-ui/icons/AddCircleRounded';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';

import { GlobalContext } from '../../../../../../store';
import { IFormat } from '../../../../../../store/admin/roundFormats/store';

import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps {
  addFormat: (formatId: number) => () => Promise<void>;
  format: IFormat;
}

const FormatOption: FC<IProps> = props => {
  const { format, addFormat } = props;

  const {
    adminRoundFormats: { roundFormats }
  } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();

  const [gameIsSelected, setGameIsSelected] = useState(false);
  const [gameIsDisabled, setGameIsDisabled] = useState(false);

  useEffect(() => {
    if (roundFormats[Number(eventId)]) {
      setGameIsSelected(roundFormats[Number(eventId)].some(rf => rf.format.id === format.id));
    }
  }, [eventId, roundFormats, eventId]);

  useEffect(() => {
    const roundFormat = roundFormats[Number(eventId)];

    if (!!roundFormat) {
      const scrambleIsSelected = roundFormat.some(rf => rf.format.prefix === 'scramble');

      const scrambleSelectedAndNotCTP = !format.prefix.includes('ctp') && scrambleIsSelected;

      const formatIsScramble = format.prefix === 'scramble';

      const uncompatibleSrambleEventIsSelected = roundFormat.some(
        rf => rf.format.prefix !== 'scramble' && rf.format.prefix !== 'ctp'
      );

      const isScrambleAndNotCompatible = formatIsScramble && uncompatibleSrambleEventIsSelected;

      setGameIsDisabled(scrambleSelectedAndNotCTP || isScrambleAndNotCompatible);
    }
  }, [roundFormats, eventId, format]);

  const handleOnClick = (formatId: number) =>
    gameIsDisabled || gameIsSelected ? undefined : addFormat(formatId);

  return (
    <li
      className={`unselected-round-format ${
        gameIsSelected ? 'selected' : gameIsDisabled ? 'disabled' : ''
      }`}
      onClick={handleOnClick(format.id)}
    >
      {gameIsSelected ? (
        <CheckCircleRounded className="icon override" />
      ) : (
        <AddCircleRounded className="icon override" />
      )}

      <span className="name">{format.name}</span>
    </li>
  );
};

export default FormatOption;
